exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".difference-area {\n  margin-top: 20px;\n}\n.difference-area .visualization-layer g.axis.x.bottom line.axis-baseline {\n  stroke: none;\n}\n.difference-area .secondary-ts-x-axis g.axis.x.bottom line.axis-baseline {\n  stroke: none;\n}\n", ""]);

